import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseConversationUnread } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { Conversation } from 'entities/Conversation'
import { Inbox } from 'entities/Inbox/model/Inbox'
import { type ConversationMenuStore } from '../store/conversationMenuStore'

export const useConversationUnread = (store: ConversationMenuStore) => {
  const entities = useEntitiesContext()
  const { inboxesStore, websocket } = entities
  const handler = (data: IResponseConversationUnread) => {
    const { inboxesMap } = inboxesStore
    const inbox = inboxesMap.get(data.inbox_id)

    if (inbox instanceof Inbox) inbox.handleUpdateUnreadCount(data)

    const conversation = new Conversation(data.conversation, entities)

    let conversationReadCount = 0
    if (data.conversation.unread_count_prev) {
      conversationReadCount = data.conversation.unread_count_prev - data.conversation.unread_count
    }

    let isIncrease = false

    if (
      (data.conversation.unread_count && !data.conversation.unread_count_prev) ||
      (data.conversation.unread_count &&
        data.conversation.unread_count_prev &&
        data.conversation.unread_count > data.conversation.unread_count_prev)
    ) {
      isIncrease = true
    }

    store.quickFiltersMenuStore.updateCountCalls()

    store.quickFiltersMenuStore.handleQuickFilterCount({
      conversation,
      isIncrease,
      decreaseCount: conversationReadCount,
    })
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationUnread, handler), [])
}
